/**
 * cart-minimum.js
 * Enforces a minimum order value of 20.00 EUR on the cart page.
 * Shows a warning message and disables the checkout button if the minimum is not met.
 *
 * NOTE: This is a UI-level check only. Server-side enforcement requires
 * Shopify Plus (checkout scripts) or a third-party app. Customers on regular
 * Shopify plans could theoretically bypass this by going to checkout directly.
 * For full enforcement, consider: https://apps.shopify.com/order-minimum-amount
 */

(function () {
  const MINIMUM_CENTS = 2000; // 20.00 EUR in cents (bestätigter Mindestbestellwert)

  function initCartMinimum() {
    const cartTotalEl = document.querySelector('[data-cart-total]') ||
                        document.querySelector('.totals__total-value') ||
                        document.querySelector('.cart-summary__total .price');

    const checkoutButtons = document.querySelectorAll(
      '[name="checkout"], .cart__checkout-button, a[href="/checkout"], button[data-checkout]'
    );

    if (!checkoutButtons.length) return;

    // Read current total from the page or from Shopify's cart API
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const totalCents = cart.total_price; // already in cents
        enforceMinimum(totalCents, checkoutButtons);
      })
      .catch(() => {
        // Fallback: parse from DOM
        if (cartTotalEl) {
          const rawText = cartTotalEl.textContent.replace(/[^0-9,\.]/g, '').replace(',', '.');
          const totalEuros = parseFloat(rawText);
          if (!isNaN(totalEuros)) {
            enforceMinimum(Math.round(totalEuros * 100), checkoutButtons);
          }
        }
      });
  }

  function enforceMinimum(totalCents, checkoutButtons) {
    // Die frühere rote Warnung entfernen — der Mindestbestellwert-Hinweis lebt jetzt
    // im Gratisversand-Balken (erste Stufe). Hier nur noch still den Checkout sperren.
    const oldWarning = document.getElementById('cart-minimum-warning');
    if (oldWarning) oldWarning.remove();

    if (totalCents < MINIMUM_CENTS) {
      checkoutButtons.forEach(btn => {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        btn.setAttribute('data-cart-minimum-blocked', 'true');
      });
    } else {
      checkoutButtons.forEach(btn => {
        if (btn.getAttribute('data-cart-minimum-blocked')) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
          btn.style.opacity = '';
          btn.style.cursor = '';
          btn.removeAttribute('data-cart-minimum-blocked');
        }
      });
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartMinimum);
  } else {
    initCartMinimum();
  }

  // Re-run after cart updates (Horizon fires this custom event)
  document.addEventListener('cart:updated', initCartMinimum);
  document.addEventListener('cart-items:update', initCartMinimum);
})();
